(()=>{
'use strict';
if(window.__skCommerceIntelligenceV2)return;window.__skCommerceIntelligenceV2=1;
const clean=s=>String(s||'').replace(/\s+/g,' ').trim();
function codeFrom(title){const m=clean(title).toUpperCase().match(/\b(?:3DB|SB|BBC|BER|BLS|BEP|WEP|TF|WF|TK|MW|OC|REF|PC|PAN|W|B)\d{1,4}\b/);return m?m[0]:''}
function familyFrom(title){
 const t=clean(title).toLowerCase();
 if(/filler/.test(t))return'Filler';
 if(/toe[\s-]*kick/.test(t))return'Toe kick';
 if(/panel/.test(t))return'Finished panel';
 if(/corner|blind|easy.reach|lazy susan/.test(t))return'Corner cabinet';
 if(/sink/.test(t))return'Sink base';
 if(/drawer/.test(t))return'Drawer base';
 if(/pantry|tall/.test(t))return'Tall / pantry';
 if(/refrigerator|oven|microwave|appliance/.test(t))return'Appliance cabinet';
 if(/wall cabinet|upper cabinet/.test(t))return'Wall cabinet';
 if(/base cabinet/.test(t))return'Base cabinet';
 return'Cabinet component';
}
function explainCode(code,family){
 if(!code)return'';
 let m=code.match(/^3DB(\d+)$/);if(m)return `${m[1]}″ nominal three-drawer base`;
 m=code.match(/^SB(\d+)$/);if(m)return `${m[1]}″ nominal sink base`;
 m=code.match(/^B(\d+)$/);if(m)return `${m[1]}″ nominal base cabinet`;
 m=code.match(/^W(\d{2})(\d{2})$/);if(m)return `${m[1]}″ W × ${m[2]}″ H wall cabinet`;
 return `${family} catalog code — confirm exact product dimensions`;
}
function enhancePdp(){
 const box=document.querySelector('[data-skbx-selected-config]');if(!box||box.querySelector('.skci-pdp-code'))return;
 const title=clean(document.querySelector('main[data-template="product"] h1')?.textContent),code=codeFrom(title);if(!code)return;
 const family=familyFrom(title),el=document.createElement('p');el.className='skci-pdp-code';el.innerHTML=`<strong>${code}</strong> · ${explainCode(code,family)}`;
 box.append(el);
}
document.addEventListener('k4l:configuration-change',e=>{window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'sk_collection_configuration_changed',finish:e.detail?.style||'',box:e.detail?.box||'',collection:location.pathname})});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhancePdp,{once:true});else enhancePdp();
})();